<template>
  <el-table-column
    v-if="operationList.length"
    :label="l('操作')"
    :width="width"
    fixed
  >
    <template #default="scope">
      <div class="links">
        <el-link
          v-for="operation of computedOperation(scope.row).links"
          :key="operation.command"
          type="warning"
          @click="handleOperation(operation.command, scope.row)"
          >{{ operation.label }}
        </el-link>

        <el-dropdown
          v-if="computedOperation(scope.row).dropdowns.length"
          @command="handleOperation($event, scope.row)"
        >
          <el-link type="warning"
            >{{l("更多")}}<el-icon><arrow-down /></el-icon
          ></el-link>
          <template #dropdown>
            <el-dropdown-menu>
              <el-dropdown-item
                v-for="operation of computedOperation(scope.row).dropdowns"
                :key="operation.command"
                :command="operation.command"
                >{{ operation.label }}</el-dropdown-item
              >
            </el-dropdown-menu>
          </template>
        </el-dropdown>
      </div>
    </template>
  </el-table-column>
</template>

<script>
export default {
  name: "TableOperation",
  props: {
    operationList: { type: Array, default: () => [] },
    width: {
      type: Number,
      default: 120,
    },
    maxCount: {
      type: Number,
      default: 2,
    },
  },
  emits: ["handleOperation"],
  data() {
    return {};
  },
  computed: {},
  methods: {
    computedOperation(row) {
      const row_operationList = this.operationList
        .filter((item) => item.is_show(row))
        .map((item) => ({ label: item.label, command: item.command }));
      let links = [],
        dropdowns = [];
      if (row_operationList.length > this.maxCount) {
        links = row_operationList.slice(0, this.maxCount - 1);
        dropdowns = row_operationList.slice(this.maxCount - 1);
      } else {
        links = row_operationList;
      }
      return { links, dropdowns };
    },
    handleOperation(command, row) {
      this.$emit("handleOperation", { command, row });
    },
  },
};
</script>


<style scoped lang="scss">
.links {
  // widows: 100%;
  // display: flex;
  // justify-content: left;
  & > * + * {
    margin-left: 10px;
  }
}
</style>

